import { FlowItemArrayType } from '../../model/flow.types';
import {
  instanceOfFlowItemSectionParent,
  instanceOfSectionEnd,
} from '../../util/flow-item.util';

export const getReorderToItemParent = (params: {
  from: number;
  to: number;
  actualItems: FlowItemArrayType[];
}): string | undefined => {
  const { from, to, actualItems } = params;

  const ranges = getSectionRanges(actualItems);

  const parentEntry = Object.entries(ranges).find(([, range]) => {
    // We need to shift the start or end index by one depending on the direction
    // of the "from" to account for the shuffle of indexes
    const rangeEnd =
      from > range.end && to === range.end ? range.end + 1 : range.end;
    const rangeStart =
      from < range.start && to === range.start ? range.start - 1 : range.start;
    return to > rangeStart && to < rangeEnd;
  });

  return parentEntry?.[0];
};

export const getReorderFromItemParent = (params: {
  from: number;
  to: number;
  actualItems: FlowItemArrayType[];
}): string | undefined => {
  const { from, actualItems } = params;

  const ranges = getSectionRanges(actualItems);

  const parentRange = Object.entries(ranges).find(([, range]) => {
    return from > range.start && from < range.end;
  });

  return parentRange?.[0];
};

type SectionRanges = {
  [sectionId: string]: {
    start: number;
    end: number;
  };
};

export const getSectionRanges = (items: FlowItemArrayType[]): SectionRanges => {
  const ranges: SectionRanges = {};

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (instanceOfFlowItemSectionParent(item)) {
      const endIndex = items.findIndex(
        (i) => instanceOfSectionEnd(i) && i.sectionId === item.id
      );
      ranges[item.id] = { start: i, end: endIndex };
    }
  }

  return ranges;
};
